import { Checkbox } from "@mui/material";
import LongMenu from "./actionsMenu";
import { deactivateStoreById } from "rest/requests";
import { activateStore } from "rest/requests";

export function formatTableData(data, setIsHandlingWarehouse, setElementToEdit) {
  //param data: list [{
  // 	"createdDate": 1624970426,
  // 	"modifiedDate": 1624970426,
  // 	"id": 1573,
  // 	"parish": {
  // 		"createdDate": 1624964435,
  // 		"modifiedDate": 1624964435,
  // 		"idParish": 417,
  // 		"canton": {
  // 			"createdDate": 1624964416,
  // 			"modifiedDate": 1624964416,
  // 			"idCanton": 70,
  // 			"province": {
  // 				"createdDate": 1624964392,
  // 				"modifiedDate": 1624964392,
  // 				"idProvince": 8,
  // 				"name": "ESMERALDAS",
  // 				"code": "08",
  // 				"active": true
  // 			},
  // 			"provinceId": 8,
  // 			"name": "QUININDE",
  // 			"code": "0804",
  // 			"active": true
  // 		},
  // 		"cantonId": 70,
  // 		"name": "MALIMPIA",
  // 		"code": "080453",
  // 		"active": true
  // 	},
  // 	"parishId": 417,
  // 	"code": "AL01572",
  // 	"identifier": "0201490752001",
  // 	"businessName": "BALANCEADOS EL CAMPO",
  // 	"areaName": "PECUARIOS",
  // 	"legalRepresentative": "BLANCA GALUTH FUENTES VEGA",
  // 	"technicalRepresentative": "BLANCA GALUTH FUENTES VEGA",
  // 	"address": "RECINTO LAS GOLONDRINAS A MEDIA CUADRA DEL ESTADIO",
  // 	"reference": "A media cuadra del estadio de Golondrinas",
  // 	"active": true
  // }]

  const changeState = (isActive, id) => {
    var action = isActive ? deactivateStoreById : activateStore;

    action(id)
      .then((req, res) => {
        console.log(res);
      })
      .catch((error) => {
        console.log("Error...", error);
      });
  };

  let _rows = [];
  data.forEach((element, index) => {
    const row = {
      Nro: index + 1,
      Codigo: element.code,
      Provincia: element.parish.canton.province.name,
      Canton: element.parish.canton.name,
      Parroquia: element.parish.name,
      Identificador: element.identifier,
      NombreComercial: element.businessName,
      Area: element.areaName,
      RepresentanteLegal: element.legalRepresentative,
      RepresentanteTecnico: element.technicalRepresentative,
      Direccion: element.address,
      Referencia: element.reference,
      state: (
        <Checkbox
          checked={element.active}
          onChange={() => changeState(element.active, element.id)}
        ></Checkbox>
      ),
      Acciones: (
        <LongMenu
          setIsHandlingWarehouse={setIsHandlingWarehouse}
          element={element}
          setElementToEdit={setElementToEdit}
        />
      ),
    };
    _rows.push(row);
  });

  return {
    columns: [
      { Header: "Nro", accessor: "Nro", width: "3%" },
      { Header: "Codigo", accessor: "Codigo" },
      { Header: "Provincia", accessor: "Provincia" },
      { Header: "Cantón", accessor: "Canton" },
      { Header: "Parroquia", accessor: "Parroquia" },
      { Header: "Identificador", accessor: "Identificador" },
      { Header: "Nombre Comercial", accessor: "NombreComercial" },
      { Header: "Área", accessor: "Area" },
      { Header: "Representante Legal", accessor: "RepresentanteLegal" },
      { Header: "Representante Técnico", accessor: "RepresentanteTecnico" },
      { Header: "Dirección", accessor: "Direccion" },
      { Header: "Referencia", accessor: "Referencia" },
      { Header: "Activo", accessor: "state", width: "3%" },
      { Header: "", accessor: "Acciones", width: "1%" },
    ],
    rows: _rows,
  };
}
